<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-4 col-sm-4 col-12">
                <div class="form-group">
                  <label>Voucher Code</label>
                  <input type="text" v-model="form.vouchercode" />
                </div>
              </div>
              <div class="col-lg-4 col-sm-4 col-12">
                <div class="form-group">
                  <label>Issue Date</label>
                  <div>
                    <b-form-input
                      type="date"
                      v-model="form.dispatchdate"
                      placeholder="Select dispatch date"
                    ></b-form-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-sm-4 col-12">
                  <div class="form-group">
                    
                    <label>Item Name</label>
                    <div>
                      <model-list-select
                      :list="itemListFromApi"
                      v-model="form.dispatchitem"
                      option-value="itemid"
                      option-text="itemname"
                      placeholder="Select item"
                      isDisabled="true"
                      :ref="`dispatchitemInput${index}`"
                      tabindex="1"
                      @keyup.enter="submitForm"
                      >
                      </model-list-select>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-sm-4 col-12">
                <div class="form-group">
                  <label>Department</label>
                  <div>
                    <model-list-select
                      :list="DeptList"
                      v-model="form.department"
                      option-value="deptid"
                      option-text="deptname"
                      placeholder="Select department"
                    >
                    </model-list-select>
                  </div>
                </div>
              </div>
                <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Quantity</label>
                  <input type="text" v-model="form.quantity" />
                </div>
              </div>
                <div class="row">
                  <div class="col-lg-12">
                <a v-on:click="postData()" class="btn btn-submit me-2"
                  >Update</a
                >
                <router-link to="saleslist" class="btn btn-cancel"
                  >Cancel</router-link
                >
              </div>
                </div>
            </div>
           </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ModelListSelect } from "vue-search-select"
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      form: {
        dispatchitem: '',
        quantity: '',
        vouchercode: '',
        department: '',
        dispatchdate: '',
        locationid:'',
      },
      filter: true,
      id: this.$route.query.id,
      title: "Edit Issued Item",
      title1: "Edit Issue",
      DeptList: [],
      itemListFromApi: [],
    };
  },
  created(){
    this.fetchItemListFromApi();
    this.fetchDeptListFromApi();
  },
  computed:{
    ...mapGetters(['getCurrentLocation']),

    currentLocation() { return this.getCurrentLocation; },
    
    locationName() {
      const loc = this.currentLocation;
      return loc ? Object.keys(loc) : null;
    },
    locationId() {
      const loc = this.currentLocation;
      return loc ? loc.id: null;
    },
  },
  methods: {
    async fetchItemListFromApi() {
    try {
      const response = await axios.get(`/v1/items?locationid=${this.locationId}`);
      this.itemListFromApi = response.data; 
    } catch (error) {
      console.error('Error fetching item list:', error);
      }
    },
    async fetchDeptListFromApi() {
    try {
      const response = await axios.get(`/v1/departments?locationid=${this.locationId}`);
      this.DeptList = response.data; 
    } catch (error) {
      console.error('Error fetching item list:', error);
      }
    },
    postData() {
      if (!this.form.dispatchitem) {
        Swal.fire("Please enter the Issue Item");
        return;
      }

      // Check if selectedDepartment is defined before accessing its properties
      if (!this.form.department) {
        Swal.fire("Please select a department");
        return;
      }
      if (!this.form.vouchercode) {
        Swal.fire("Please enter the Voucher Code");
        return;
      }
      const selectedDate = moment(this.form.dispatchdate).format("YYYY-MM-DD");
      const currentTime = moment().format("HH:mm:ss");

      const combinedDateTime = `${selectedDate} ${currentTime}`;

      this.form.dispatchdate = combinedDateTime;

      axios
      .put('/v1/dispatches/' + this.id, this.form)
      .then(response => {
        Swal.fire("Issue updated successfully");
        this.$router.push({ path: '/saleslist' });
      })
      .catch(error => {
        console.log(error)
        Swal.fire(error.response.data.detail);
      });
    },
    async getDispatchById(id) {
      try {
    const response = await axios.get('/v1/dispatches/' + id);
    this.form = response.data;

    if (this.form.dispatchdate) {
      const date = new Date(this.form.dispatchdate);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      this.form.dispatchdate = `${year}-${month}-${day}`;
    }
    } catch (error) {
      console.log(error);
      this.errored = true;
    }
  }
  },
  beforeMount() {
    this.id = this.$route.query.id
    this.getDispatchById(this.id);
  },
  components: {
    ModelListSelect
  },
  name: "edit-sales",
};
</script>
